function triggerAnimation(el, duration) {
  if (duration === 0) {
    el.style.opacity = '1';
    el.style.transform = 'none';
    return;
  }
  el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
  requestAnimationFrame(() => {
    el.style.opacity = '1';
    el.style.transform = 'none';
  });
}

const observer = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        // Handle <source> and <img> inside a <picture>
        if (el.tagName === 'PICTURE') {
          // Find the first source whose media query matches
          const matchedSource = [...el.querySelectorAll('source[data-srcset]')].find(
            (s) => !s.media || window.matchMedia(s.media).matches
          );
          const img = el.querySelector('img[data-src]');

          // Set all the attributes so the browser has what it needs
          el.querySelectorAll('source[data-srcset]').forEach((s) => {
            s.srcset = s.dataset.srcset;
          });
          if (img) img.src = img.dataset.src;

          // Preload whichever URL the browser will actually display
          const activeUrl = matchedSource
            ? matchedSource.dataset.srcset
            : img?.dataset.src;

          if (activeUrl) {
            el._preloader = new Image();
            el._preloader.onload = () => triggerAnimation(el, el._lazyDuration);
            el._preloader.src = activeUrl;
            if (el._preloader.complete) triggerAnimation(el, el._lazyDuration);
          }
        }

        // Handle a plain <img>
        if (el.tagName === 'IMG') {
          if (el.dataset.src) {
            el.addEventListener('load', () => triggerAnimation(el, el._lazyDuration), { once: true });
            el.src = el.dataset.src;
            if (el.complete) triggerAnimation(el, el._lazyDuration);
          }
          if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        }

        observer.unobserve(el);
      });
    }, {
      rootMargin: '200px',
    })
  : null;

export function lazyLoad(el, duration = 1000) {
  el._lazyDuration = duration;
  if (observer) observer.observe(el);
}
